"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradleStateCache = exports.META_FILE_DIR = void 0;
const core = __importStar(require("@actions/core"));
const exec = __importStar(require("@actions/exec"));
const path_1 = __importDefault(require("path"));
const fs_1 = __importDefault(require("fs"));
const params = __importStar(require("./input-params"));
const cache_utils_1 = require("./cache-utils");
const cache_extract_entries_1 = require("./cache-extract-entries");
const RESTORED_CACHE_KEY_KEY = 'restored-cache-key';
exports.META_FILE_DIR = '.gradle-build-action';
class GradleStateCache {
    constructor(gradleUserHome) {
        this.gradleUserHome = gradleUserHome;
        this.cacheName = 'gradle';
        this.cacheDescription = 'Gradle User Home';
    }
    init() {
        const actionCacheDir = path_1.default.resolve(this.gradleUserHome, '.gradle-build-action');
        fs_1.default.mkdirSync(actionCacheDir, { recursive: true });
        const initScriptsDir = path_1.default.resolve(this.gradleUserHome, 'init.d');
        fs_1.default.mkdirSync(initScriptsDir, { recursive: true });
        this.initializeGradleUserHome(this.gradleUserHome, initScriptsDir);
    }
    cacheOutputExists() {
        const cachesDir = path_1.default.resolve(this.gradleUserHome, 'caches');
        if (fs_1.default.existsSync(cachesDir)) {
            (0, cache_utils_1.cacheDebug)(`Cache output exists at ${cachesDir}`);
            return true;
        }
        return false;
    }
    restore(listener) {
        return __awaiter(this, void 0, void 0, function* () {
            const entryListener = listener.entry(this.cacheDescription);
            const cacheKey = (0, cache_utils_1.generateCacheKey)(this.cacheName);
            (0, cache_utils_1.cacheDebug)(`Requesting ${this.cacheDescription} with
    key:${cacheKey.key}
    restoreKeys:[${cacheKey.restoreKeys}]`);
            const cacheResult = yield (0, cache_utils_1.restoreCache)(this.getCachePath(), cacheKey.key, cacheKey.restoreKeys, entryListener);
            if (!cacheResult) {
                core.info(`${this.cacheDescription} cache not found. Will initialize empty.`);
                return;
            }
            core.saveState(RESTORED_CACHE_KEY_KEY, cacheResult.key);
            core.info(`Restored ${this.cacheDescription} from cache key: ${cacheResult.key}`);
            try {
                yield this.afterRestore(listener);
            }
            catch (error) {
                core.warning(`Restore ${this.cacheDescription} failed in 'afterRestore': ${error}`);
            }
        });
    }
    afterRestore(listener) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.debugReportGradleUserHomeSize('as restored from cache');
            yield new cache_extract_entries_1.GradleHomeEntryExtractor(this.gradleUserHome).restore(listener);
            yield this.debugReportGradleUserHomeSize('after restoring common artifacts');
        });
    }
    save(listener) {
        return __awaiter(this, void 0, void 0, function* () {
            const cacheKey = (0, cache_utils_1.generateCacheKey)(this.cacheName).key;
            const restoredCacheKey = core.getState(RESTORED_CACHE_KEY_KEY);
            const gradleHomeEntryListener = listener.entry(this.cacheDescription);
            if (restoredCacheKey && cacheKey === restoredCacheKey) {
                core.info(`Cache hit occurred on the cache key ${cacheKey}, not saving cache.`);
                for (const entryListener of listener.cacheEntries) {
                    if (entryListener === gradleHomeEntryListener) {
                        entryListener.markNotSaved('cache key not changed');
                    }
                    else {
                        entryListener.markNotSaved(`referencing '${this.cacheDescription}' cache entry not saved`);
                    }
                }
                return;
            }
            try {
                yield this.beforeSave(listener);
            }
            catch (error) {
                core.warning(`Save ${this.cacheDescription} failed in 'beforeSave': ${error}`);
                return;
            }
            core.info(`Caching ${this.cacheDescription} with cache key: ${cacheKey}`);
            const cachePath = this.getCachePath();
            yield (0, cache_utils_1.saveCache)(cachePath, cacheKey, gradleHomeEntryListener);
            return;
        });
    }
    beforeSave(listener) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.debugReportGradleUserHomeSize('before saving common artifacts');
            this.deleteExcludedPaths();
            yield Promise.all([
                new cache_extract_entries_1.GradleHomeEntryExtractor(this.gradleUserHome).extract(listener)
            ]);
            yield this.debugReportGradleUserHomeSize("after extracting common artifacts (only 'caches' and 'notifications' will be stored)");
        });
    }
    deleteExcludedPaths() {
        const rawPaths = params.getCacheExcludes();
        const resolvedPaths = rawPaths.map(x => path_1.default.resolve(this.gradleUserHome, x));
        for (const p of resolvedPaths) {
            (0, cache_utils_1.cacheDebug)(`Deleting excluded path: ${p}`);
            (0, cache_utils_1.tryDelete)(p);
        }
    }
    getCachePath() {
        const rawPaths = params.getCacheIncludes();
        rawPaths.push(exports.META_FILE_DIR);
        const resolvedPaths = rawPaths.map(x => this.resolveCachePath(x));
        (0, cache_utils_1.cacheDebug)(`Using cache paths: ${resolvedPaths}`);
        return resolvedPaths;
    }
    resolveCachePath(rawPath) {
        if (rawPath.startsWith('!')) {
            const resolved = this.resolveCachePath(rawPath.substring(1));
            return `!${resolved}`;
        }
        return path_1.default.resolve(this.gradleUserHome, rawPath);
    }
    initializeGradleUserHome(gradleUserHome, initScriptsDir) {
        const gradleProperties = path_1.default.resolve(gradleUserHome, 'gradle.properties');
        const existingGradleProperties = fs_1.default.existsSync(gradleProperties)
            ? fs_1.default.readFileSync(gradleProperties, 'utf8')
            : '';
        if (!existingGradleProperties.includes('org.gradle.java.installations.fromEnv=')) {
            fs_1.default.appendFileSync(gradleProperties, `
# Auto-detect pre-installed JDKs
org.gradle.java.installations.fromEnv=JAVA_HOME_8_X64,JAVA_HOME_11_X64,JAVA_HOME_17_X64
`);
        }
        const initScriptFilenames = [
            'gradle-build-action.build-result-capture.init.gradle',
            'gradle-build-action.build-result-capture-service.plugin.groovy',
            'gradle-build-action.github-dependency-graph.init.gradle',
            'gradle-build-action.github-dependency-graph-gradle-plugin-apply.groovy',
            'gradle-build-action.inject-gradle-enterprise.init.gradle'
        ];
        for (const initScriptFilename of initScriptFilenames) {
            const initScriptContent = this.readInitScriptAsString(initScriptFilename);
            const initScriptPath = path_1.default.resolve(initScriptsDir, initScriptFilename);
            fs_1.default.writeFileSync(initScriptPath, initScriptContent);
        }
    }
    readInitScriptAsString(resource) {
        const absolutePath = path_1.default.resolve(__dirname, '..', '..', 'src', 'resources', 'init-scripts', resource);
        return fs_1.default.readFileSync(absolutePath, 'utf8');
    }
    debugReportGradleUserHomeSize(label) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(0, cache_utils_1.isCacheDebuggingEnabled)()) {
                return;
            }
            if (!fs_1.default.existsSync(this.gradleUserHome)) {
                return;
            }
            const result = yield exec.getExecOutput('du', ['-h', '-c', '-t', '5M'], {
                cwd: this.gradleUserHome,
                silent: true,
                ignoreReturnCode: true
            });
            core.info(`Gradle User Home (directories >5M): ${label}`);
            core.info(result.stdout
                .trimEnd()
                .replace(/\t/g, '    ')
                .split('\n')
                .map(it => {
                return `  ${it}`;
            })
                .join('\n'));
            core.info('-----------------------');
        });
    }
}
exports.GradleStateCache = GradleStateCache;
